const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");


export const fetchNotificationsByType = async (type) => {
  try {
    const response = await fetch(`${BASE_URL}/getNotificationsByType/${type}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
    if (!response.ok) {
      throw new Error(`Failed to fetch notifications of type ${type}`);
    }
    return await response.json(); // Parse JSON response
  } catch (error) {
    console.error(`Error fetching notifications of type ${type}:`, error);
    throw error;
  }
};
